import React, { Component } from "react";
import connected from "./connected";
import TimezoneSelect from "../TimezoneSelect";
import TextBtn from "../Buttons/Text";
import FullBtn from "../Buttons/Full";
import Modal, { CloseBtn } from "../Modal";
import cx from "../../utils/cx";
import { amOrPm, localTime, getHours, getMinutes } from "../../utils/time";

class ZoneSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      changed: false,
      timezone: props.timezone
    };
  }
  componentDidMount() {
    this.props.setSystemTimezone();
  }
  openModal() {
    this.setState({ open: true });
    this.setState({ timezone: this.props.timezone });
  }
  closeModal() {
    this.setState({ open: false });
  }
  updateTimezone(timezone) {
    this.setState({ changed: true, timezone });
  }
  saveTimezone() {
    this.setState({ changed: false });
    this.props.updateTimezone(this.state.timezone);
    this.closeModal();
  }
  render() {
    const { open, changed, timezone } = this.state;
    const { time, timezone: currentTimezone } = this.props;
    const date = localTime(time, currentTimezone);
    const display = `${getHours(date)}:${getMinutes(date)}${amOrPm(date)}`;
    return (
      <div>
        <Modal
          open={open}
          onClose={this.closeModal.bind(this)}
          scale={false}
          fadeUp={false}
        >
          {open ? (
            <div
              className="position-relative bg-white shadow-lg"
              style={{ height: 540, overflow: "hidden" }}
            >
              <CloseBtn onClick={this.closeModal.bind(this)} />
              <h5 className="bold px-4 py-2 m-0">Change your time</h5>
              <TimezoneSelect
                className="position-relative"
                style={{ height: 420 }}
                timezone={timezone}
                onChange={this.updateTimezone.bind(this)}
              />
              <FullBtn
                fontSize={18}
                className="position-relative text-white bg-blue bold py-2"
                onClick={this.saveTimezone.bind(this)}
                disabled={!changed}
              >
                Done
              </FullBtn>
            </div>
          ) : (
            ""
          )}
        </Modal>
        <div className="border-bottom pl-4 pr-2 pt-4 pb-1">
          <h5 className="bold mb-1">Timezone:</h5>
          <div className="mb-1 d-flex">
            <p className="m-0">Your current time is {display}</p>
            <TextBtn
              onClick={this.openModal.bind(this)}
              className="ml-auto text-blue m-0 bold"
            >
              Change
            </TextBtn>
          </div>
        </div>
      </div>
    );
  }
}

export default connected(ZoneSelect);



// WEBPACK FOOTER //
// ./src/components/ZoneSelect/index.js